import { action } from 'easy-peasy';
import { ISetLocationGroupAction } from '../types';

const setLocationGroup: ISetLocationGroupAction = action((state, payload) => {
  state.current = payload;
});

export default setLocationGroup;
